import { Injectable } from '@angular/core';
import { ToastInfo } from '../models/toast-info.model';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  public toasts: ToastInfo[] = [];
  
  constructor() { }

  show(toast: ToastInfo) {
    this.toasts.push(toast);
  }

  remove(toast: ToastInfo) {
    this.toasts = this.toasts.filter(t => t != toast);
  }
}
